import React from "react";
import {
  Briefcase,
  ShieldCheck,
  CalendarRange,
  Users2,
  UserPlus,
  ArrowRight,
} from "lucide-react";

const services = [
  {
    icon: Briefcase,
    title: "Recruitment & Hiring",
    desc: "Tech / Non-tech roles filled mostly in 7-14 days! We source, screen and shortlist candidates that fit your stage and culture.",
    span: "lg:col-span-6",
    cta: "Hire Talent",
  },
  {
    icon: ShieldCheck,
    title: "Startup HR Setup",
    desc: "Policies, onboarding flows and HR processes designed for early-stage teams.",
    span: "lg:col-span-6",
    cta: "Try Now",
  },
  {
    icon: UserPlus,
    title: "Onboarding Setup",
    desc: "Structured onboarding that helps new hires settle in and ramp up faster.",
    span: "lg:col-span-4",
    cta: "Try Now",
  },
  {
    icon: CalendarRange,
    title: "Monthly HR Retainer",
    desc: "Get dedicated hires monthly without the cost of a full-time hire.",
    span: "lg:col-span-4",
    cta: "Hire Talent",
  },
  {
    icon: Users2,
    title: "Bulk Hiring Solutions",
    desc: "Scale teams quickly for expansion, seasonal demand or new-market launches.",
    span: "lg:col-span-4",
    cta: "Hire Talent",
  },
];

export default function ServicesCompanies() {
  return (
    <section
      id="for-companies"
      className="py-20 md:py-28 bg-brand-soft/30"
      data-testid="services-companies-section"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="uppercase text-xs tracking-[0.22em] font-bold text-brand-primary">
            For Companies
          </span>
          <h2 className="mt-3 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Everything you need to build a strong, steady team.
          </h2>
          <p className="mt-4 text-brand-muted leading-relaxed">
            From a single critical hire to scaling your entire operations team — we plug
            in, listen, and deliver quality talent that fits your stage.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6">
          {services.map(({ icon: Icon, title, desc, span, cta }, i) => (
            <div
              key={title}
              className={`${span} relative rounded-3xl p-8 lg:p-10 bg-white border border-brand-border shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md flex flex-col`}
              data-testid={`company-service-card-${i}`}
            >
              <div className="w-12 h-12 rounded-xl grid place-items-center bg-brand-soft text-brand-primary">
                <Icon size={22} />
              </div>
              <h3 className="mt-6 font-heading text-2xl font-medium">{title}</h3>
              <p className="mt-3 leading-relaxed text-brand-muted flex-1">{desc}</p>
              <a
                href="#contact"
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand-primary"
                data-testid={`company-service-cta-${i}`}
              >
                {cta} <ArrowRight size={14} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
